import { render, staticRenderFns } from "./TeacherQuickView.vue?vue&type=template&id=795be36d&scoped=true"
import script from "./TeacherQuickView.vue?vue&type=script&lang=js"
export * from "./TeacherQuickView.vue?vue&type=script&lang=js"
import style0 from "./TeacherQuickView.vue?vue&type=style&index=0&id=795be36d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795be36d",
  null
  
)

export default component.exports